import { PROMO_RATE } from '@klaro7/shared-types';

/**
 * Leva promo nell'overlay di pausa (credito esaurito), SOLO per utenti con la
 * promo prima ricarica attiva: ricaricando ora la tariffa 0,99 €/min resta
 * attiva. Copy-only, validato dal team marketing/PO/UX (2026-07-08): nessun
 * bonus condizionato, nessuna pressione — la promo è presentata come cosa che
 * l'utente conserva, non che sta per perdere.
 *
 * I minuti residui vanno calcolati al netto del costo della sessione in corso:
 * il budget promo (promoCreditsRemaining) viene scalato solo al settle, quindi
 * senza sottrarre currentCost promettersi minuti già consumati. Sotto il
 * minuto intero la riga sparisce.
 */
export function PausePromoPitch({
  promoCreditsRemaining,
  currentCost,
}: {
  promoCreditsRemaining: number;
  currentCost: number;
}) {
  const promoMinutes = Math.max(
    0,
    Math.floor((promoCreditsRemaining - currentCost) / PROMO_RATE)
  );

  return (
    <div className="mt-1 text-sm text-neutral-600">
      <p>
        Ricarica per continuare: la tua tariffa promo di{' '}
        <strong className="text-neutral-900">0,99 €/min</strong> resta attiva.
      </p>
      {promoMinutes >= 1 && (
        <p className="mt-1 text-xs text-neutral-500">
          Hai ancora ~{promoMinutes} min a 0,99 €/min dopo la ricarica.
        </p>
      )}
    </div>
  );
}
